// extracted by mini-css-extract-plugin
export var blue = "_10-g";
export var brand = "_10-c";
export var darkGrey = "_10-f";
export var disabled = "_10-6";
export var disabledSubtle = "_10-7";
export var error = "_10-8";
export var green = "_10-h";
export var grey = "_10-e";
export var icon = "_10-0";
export var inherit = "_10-b";
export var lightGrey = "_10-d";
export var orange = "_10-j";
export var pink = "_10-l";
export var primary = "_10-1";
export var purple = "_10-m";
export var quaternary = "_10-4";
export var quinary = "_10-5";
export var red = "_10-k";
export var secondary = "_10-2";
export var success = "_10-a";
export var tertiary = "_10-3";
export var warning = "_10-9";
export var white = "_10-n";
export var yellow = "_10-i";